import { useLang } from "@/lib/i18n";
import { useSEO } from "@/lib/seo";
import { CONTACT_EMAIL } from "@/lib/api";

const Page = ({ title, children, testId }) => (
  <div className="bg-[#070809] pt-28 md:pt-36">
    <div className="container-x max-w-3xl pb-24">
      <h1 className="display text-4xl sm:text-5xl" data-testid={testId}>{title}</h1>
      <div className="mt-12 space-y-6 text-base leading-relaxed text-[#c7ccd4]">{children}</div>
    </div>
  </div>
);

export const Legal = () => {
  const { t, lang } = useLang();
  useSEO({ title: `${t("legal_title")} — Palissiere Motor Group`, lang });
  const fr = lang === "fr";
  return (
    <Page title={t("legal_title")} testId="legal-title">
      <p><strong className="text-white">Palissiere Motor Group</strong><br />{fr ? "Courtage automobile & sourcing international" : "Automotive brokerage & international sourcing"}</p>
      <p>Email : <a className="link-underline" href={`mailto:${CONTACT_EMAIL}`}>{CONTACT_EMAIL}</a><br />WhatsApp : +33 6 41 34 97 33</p>
      <p>{fr ? "Les informations relatives à l'éditeur, au directeur de la publication et à l'hébergeur seront complétées par l'administrateur du site." : "Publisher, editorial director and hosting details will be completed by the site administrator."}</p>
      <p>{fr ? "Les véhicules présentés le sont à titre indicatif ; leur disponibilité et leur prix peuvent évoluer sans préavis. Les photographies non fournies par les propriétaires proviennent de banques d'images libres de droits pour un usage commercial." : "Vehicles are presented for information; availability and price may change without notice. Photography not supplied by owners is sourced from royalty-free libraries licensed for commercial use."}</p>
    </Page>
  );
};

export const Privacy = () => {
  const { t, lang } = useLang();
  useSEO({ title: `${t("privacy_title")} — Palissiere Motor Group`, lang });
  const fr = lang === "fr";
  return (
    <Page title={t("privacy_title")} testId="privacy-title">
      <p>{fr ? "Les données transmises via les formulaires (nom, email, téléphone, WhatsApp, pays, informations véhicule) sont utilisées uniquement pour traiter votre demande et vous recontacter. Elles ne sont ni vendues ni partagées avec des tiers à des fins commerciales." : "Data submitted through our forms (name, email, phone, WhatsApp, country, vehicle information) is used solely to process your request and get back to you. It is neither sold nor shared with third parties for marketing purposes."}</p>
      <p>{fr ? "Vous pouvez demander l'accès, la rectification ou la suppression de vos données à tout moment en écrivant à " : "You may request access to, correction or deletion of your data at any time by writing to "}<a className="link-underline" href={`mailto:${CONTACT_EMAIL}`}>{CONTACT_EMAIL}</a>.</p>
      <p>{fr ? "Ce site n'utilise pas de cookies publicitaires. Des mesures d'audience anonymisées peuvent être collectées afin d'améliorer l'expérience." : "This website does not use advertising cookies. Anonymised audience metrics may be collected to improve the experience."}</p>
    </Page>
  );
};
